/**
 * Convert value into number.
 *
 * @param {String|Number} number
 * @returns {*}
 */
export function toNumber(number) {
  var result;

  if (typeof number === 'number') {
    result = number;
  } else if (typeof number === 'string') {
    result = number.indexOf('.') > -1 ? parseFloat(number) : parseInt(number, 10);
  }

  return result;
}
/**
 * Invert provided number.
 *
 * @param {Number} number
 * @returns {Number} Returns inverted number.
 */

export function invertNumber(number) {
  return -1 * toNumber(number);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_hot-formula-parser@4.0.0@hot-formula-parser/helper/number.mjs
// module id = null
// module chunks = 